import dateTimeHelper from "../../Helpers/datetimeHelper";
import { calendarConfig } from "./calendarConfig";
import $ from "jquery";


export default class CalendarParameretObject
{
    constructor (calendarDayList, showBeforeWorkingHours, showAfterWorkingHours) 
    {
        if (!$(`#${calendarDayList[ 0 ].divId}`)[ 0 ]) return;
        this.visibleStartTime = showBeforeWorkingHours ? calendarConfig.dailyStartTime : calendarConfig.dailyWorkStartTime;
        this.visibleEndTime = showAfterWorkingHours ? calendarConfig.dailyEndTime : calendarConfig.dailyWorkEndTime;
        this.widthOfDayDiv = $(`#${calendarDayList[ 0 ].divId}`)[ 0 ].offsetWidth;
        this.borderOfDayDiv = ($(`#${calendarDayList[ 0 ].divId}`)[ 0 ].offsetWidth - $(`#${calendarDayList[ 0 ].divId}`)[ 0 ].clientWidth) / 2;
        this.visibleStartToEnd
            = dateTimeHelper.convertTimeToMinutes(this.visibleEndTime)
            - dateTimeHelper.convertTimeToMinutes(this.visibleStartTime);
        this.heightOfDayTimeframesDiv = $(`#${calendarDayList[ 0 ].divId}timeframes`)[ 0 ].clientHeight;
        this.heightOfDayHeaderDiv = $(`#${calendarDayList[ 0 ].divId}header`)[ 0 ].offsetHeight;
        this.firstDay = calendarDayList[ 0 ].Date;
        this.lastDay = dateTimeHelper.addDaysToDate(calendarDayList[ calendarDayList.length - 1 ].Date, 1);
        return this;
    }
}
